module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _vm._v(" Copyright © 2011 by Ward Just")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ALL RIGHTS RESERVED")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Library of Congress has cataloged the print edition as follows:"), _c('br'), _vm._v("\nJust, Ward S."), _c('br'), _vm._v("\nRodin’s debutante / Ward Just."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-50419-3"), _c('br'), _vm._v("\n1. Coming of age—Fiction. 2. Boarding schools—Fiction. 3. Friendship—Fiction. 4. Maturation (Psychology)—Fiction. I. Title."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("PS")]), _vm._v("3560."), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("U")]), _vm._v("75"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("R")]), _vm._v("63 2011"), _c('br'), _vm._v("\n813'.54—dc22 2010042695")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("eISBN 978-0-547-50420-9"), _c('br'), _vm._v("\nv4.1214")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1152e084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0